export const start = "START"
export const stop = "STOP"